import React from 'react'
import { useLinkConfirm } from './use-link-confirm'
import { CodeScreen, MethodHandoff, NoWayCard, WaysScreen } from './link-confirm-screens'

// The held sign-in's confirm page (SSO link confirmation, plan 5.1): a
// public sign-in button (Google, Microsoft, Facebook...) met an existing
// EducationXR account it isn't connected to yet, so before it signs the
// person in they show the account is theirs, once:
//
//   - the account's password;
//   - a sign-in with a method the account already has (a full-page trip
//     through that method; auth brings the browser back here, or on to the
//     organization step);
//   - an 8-digit code emailed to the account's own address (screen B).
//
// open-link.js owns the state read and where the page goes; the page's
// state and steps are use-link-confirm.js's, its screens
// link-confirm-screens.js's, every sentence open-link-confirm-copy.js's. A
// spent sign-in, another browser, and "no longer held" go back to
// open-link.js (onSpent, onOtherBrowser, onRecheck); a proof that confirms
// calls onConfirmed(next). Never a 401 here: nothing on this page signs the
// browser out.

const START_AGAIN = '/auth/email'

export const OpenLinkConfirm = ({ token, state, details, onConfirmed, onRecheck, onSpent, onOtherBrowser }) => {
  const model = useLinkConfirm({ token, state, onConfirmed, onRecheck, onSpent, onOtherBrowser })

  const provider = state.provider || {}
  const email = details && details.email
  const cancelURL = details && details.redirectCancelURL
  const onCancel = () => (window.location = cancelURL || START_AGAIN)

  if (model.noWay) return <NoWayCard model={model} state={state} onCancel={onCancel} />

  const method = model.ways.linked.find(m => m.identifier === model.busy)

  if (method) return <MethodHandoff provider={provider} method={method} />

  return model.screen === 'code'
    ? <CodeScreen model={model} provider={provider} email={email} onCancel={onCancel} />
    : <WaysScreen model={model} provider={provider} email={email} onCancel={onCancel} />
}
